<template>
  <section>
    <div class="table-top">
      <div class="table-top-left">
        <div class="table-search">
          <input
            type="text"
            class="with-icon"
            placeholder="Search for..."
            @input="onSearchData" />
          <div class="suffix icon-inside"><i class="icon icon-search"></i></div>
        </div>
        <div v-if="isFilter">
          <button class="btn table-filter filter-button" @click="showFilter">
            <i class="icon icon-filter-off"></i> Filter
          </button>
        </div>
      </div>
      <div class="table-top-right">
        <div class="table-buttons">
          <slot name="table-top"></slot>
          <button v-if="isExport" class="btn" id="exportData">Export</button>
        </div>
      </div>
    </div>

    <div class="table-middle"></div>

    <table class="table compact split-dashed" ref="table"></table>

    <div class="table-bottom">
      <div class="pagination-group" v-if="isPagination">
        <ul class="pagination"></ul>

        <div class="actions" v-if="tableData.rowsPerPage === undefined">
          <label class="left">Go to</label>
          <input type="number" min="1" />

          <label class="left">Show</label>
          <div class="select" data-type="single">
            <button class="btn current-options">5</button>

            <div class="options-list">
              <div class="item">10</div>
              <div class="item active">15</div>
              <div class="item">20</div>
              <div class="item">All</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Table } from '@eds/vanilla';
import DialogComponent from '../base.component/DialogComponent.vue';
import ProductDialogComponent from './ProductDialogComponent.vue';

export default {
  components: {
    DialogComponent,
    ProductDialogComponent
  },

  data() {
    return {
      table: Table,
      showFilters: true
    };
  },

  props: {
    tableData: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => []
    },
    isExport: {
      type: Boolean,
      default: false,
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    itemPerPage: {
      type: Number,
      default: 5
    },
    isFilter: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    data: function() {
      this.table.update(this.tableData.data);
    },

    'table.selected': function() {
      this.$emit('onRowSelected', this.table.selected);
    }
  },

  mounted() {
    this.initTable();

    if (this.isFilter) {
      this.tableData.columns.forEach(column => {
          const isFilter = !!column.filter;

          if (!isFilter) {
            const node = document.querySelector(`td[data-key="${column.key}"`);
            node.children[0].style.display = 'none';
          }
        })
    }
  },

  methods: {
    initTable() {
      this.table = new Table(this.$refs.table, {
        data: this.tableData.data,
        columns: this.tableData.columns,
        actions: true,
        onCreatedActionsCell: this.tableData.onCreatedActionsCell,
        beforeCreatedBody: this.tableData.beforeCreatedBody,
        onCreatedDetailsRow: this.tableData?.onCreatedDetailsRow,
        selectable: this.tableData.selectable,
        rowsPerPage: this.tableData.rowsPerPage,
        sortable: this.tableData?.sortable,
        height: this.tableData?.height,
        expandable: this.tableData?.expandable
      });

      this.table.init();
    },

    // TODO: Need to implement search on the server side
    onSearchData(ev) {
      let tmp = [];

      this.tableData.columns.forEach((column) => {
        if (column.searchable) {
          this.tableData.data.forEach((item) => {
            if (
              item[column.key]
                .toLowerCase()
                .includes(ev.target.value.toLowerCase())
            ) {
              if (!tmp.includes(item)) {
                tmp.push(item);
              }
            }
          });
        }
      });

      this.table.update(tmp);
    },

    showFilter() {
      this.showFilters = !this.showFilters;

      if (this.showFilters) {
        this.tableData.columns.forEach(column => {
          const isFilter = !!column.filter;

          if (!isFilter) {
            const node = document.querySelector(`td[data-key="${column.key}"`);
            node.children[0].style.display = 'none';
          }
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.table-search {
  margin-left: 0 !important;
}

.filter-button {
  margin-left: 1rem;
}

.filters {
  height: 3rem !important;
}
</style>